import {
  createRecipe,
  createRecipeIngredientsGroup,
  CreateRecipeIngredientsGroupMutation,
  CreateRecipeIngredientsGroupMutationVariables,
  CreateRecipeMutation,
  CreateRecipeMutationVariables,
  deleteRecipe,
  DeleteRecipeMutation,
  DeleteRecipeMutationVariables,
  graphqlCall,
  updateRecipe,
  UpdateRecipeMutation,
  UpdateRecipeMutationVariables,
} from '@akin-home/amplify';

export const updateRecipeMutation = (params: UpdateRecipeMutationVariables) =>
  graphqlCall<UpdateRecipeMutation>(updateRecipe, params);

export const createRecipeMutation = (params: CreateRecipeMutationVariables) =>
  graphqlCall<CreateRecipeMutation>(createRecipe, params);

export const deleteRecipeMutation = (params: DeleteRecipeMutationVariables) =>
  graphqlCall<DeleteRecipeMutation>(deleteRecipe, params);

export const createRecordIngredientsGroupMutation = (
  params: CreateRecipeIngredientsGroupMutationVariables
) =>
  graphqlCall<CreateRecipeIngredientsGroupMutation>(
    createRecipeIngredientsGroup,
    params
  );

